export default __webpack_public_path__ + "static/media/btn_default_template.5e36c376.svg";